var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7088 62.5501L48.7485 8.92531C47.0269 5.9435 43.9434 4.16309 40.5 4.16309C37.0567 4.16309 33.973 5.9435 32.2514 8.92531L1.29129 62.5499C-0.43043 65.532 -0.43043 69.0925 1.29129 72.0745C3.01301 75.0565 6.09639 76.8367 9.53983 76.8367H71.4601C74.9034 76.8367 77.9869 75.0563 79.7088 72.0747C81.4305 69.0925 81.4305 65.532 79.7088 62.5501ZM75.599 69.7019C74.7351 71.1982 73.1878 72.0914 71.4601 72.0914H9.53983C7.81194 72.0914 6.26471 71.1982 5.40093 69.7019C4.53714 68.2056 4.53714 66.4192 5.40093 64.9229L36.3614 11.2982C37.2252 9.80191 38.7724 8.9087 40.5001 8.9087C42.2277 8.9087 43.7751 9.80191 44.6389 11.2982L75.5992 64.9229C76.4628 66.4192 76.4628 68.2056 75.599 69.7019Z",
    fill: "#EDD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8724 27.8452H38.127V51.5729H42.8724V27.8452Z",
    fill: "#EDD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4997 56.3179C38.7552 56.3179 37.3359 57.7371 37.3359 59.4816C37.3359 61.2261 38.7552 62.6454 40.4997 62.6454C42.2441 62.6454 43.6635 61.2261 43.6635 59.4816C43.6635 57.7371 42.2442 56.3179 40.4997 56.3179Z",
    fill: "#EDD34D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowAlert);
export default __webpack_public_path__ + "static/media/yellowAlert.3ff4439bc9d567b94a7339917e2eea0f.svg";
export { ForwardRef as ReactComponent };